<mat-sidenav-container class="app-container" [autosize]="false">
  <mat-sidenav class="mat-drawer mat-sidenav main-app-sidenav" #sidenav mode="side" opened="true">
    <app-navigation
      class="navigation fill-vertical-horizontal"
      [menuItems]="menuItems"
      [bottomMenuItems]="bottomMenuItems"
    ></app-navigation>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar *ngIf="mainTitle">
      <h5 class="top-bar-view-title full-width">{{ mainTitle.val | translate }}</h5>
      <span class="fill-remaining-space"></span>
    </mat-toolbar>

    <div [class]="'sidenav-inner-content ' + extraClass">
      <router-outlet (activate)="routeActivated($event)"></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
